import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import Stack from '@mui/material/Stack'
import { FilterMode } from './FilterMode'
import { SortMode } from './SortMode'
import { StyledCheckbox } from '@/components/molecules/input/StyledCheckbox'
import { RcTrans } from '@/components/atoms/RcTrans'
import { RcIcon } from '@/components/atoms/RcIcon'

const filterModes = [
  FilterMode.HasIssues,
  FilterMode.NoIssues,
  FilterMode.Dropped
]
const sortModes = [SortMode.NameAscending, SortMode.NameDescending]

export const TeamStatusMenu = ({
  filterMode,
  sortMode,
  onSelected
}: {
  filterMode: FilterMode | undefined
  sortMode: SortMode | undefined
  onSelected: (filter?: FilterMode, sort?: SortMode) => any
}) => {
  return (
    <>
      <Box p={2}>
        <FormControl sx={{ px: 2 }}>
          <FormGroup>
            <FormControlLabel
              label={<RcTrans i18nKey='competition:teams.filters.has-issues' />}
              control={
                <StyledCheckbox
                  checked={filterMode === FilterMode.HasIssues}
                  onChange={() =>
                    onSelected(
                      filterMode === FilterMode.HasIssues
                        ? undefined
                        : FilterMode.HasIssues
                    )
                  }
                />
              }
            />
            <FormControlLabel
              label={<RcTrans i18nKey='competition:teams.filters.no-issues' />}
              control={
                <StyledCheckbox
                  checked={filterMode === FilterMode.NoIssues}
                  onChange={() =>
                    onSelected(
                      filterMode === FilterMode.NoIssues
                        ? undefined
                        : FilterMode.NoIssues
                    )
                  }
                />
              }
            />
            <FormControlLabel
              label={<RcTrans i18nKey='competition:teams.filters.dropped' />}
              control={
                <StyledCheckbox
                  checked={filterMode === FilterMode.Dropped}
                  onChange={() =>
                    onSelected(
                      filterMode === FilterMode.Dropped
                        ? undefined
                        : FilterMode.Dropped
                    )
                  }
                />
              }
            />
          </FormGroup>
        </FormControl>
      </Box>
      <Divider />
      <Box p={2}>
        <FormControl fullWidth>
          <Select
            displayEmpty
            value={sortMode}
            onChange={ev => onSelected(filterMode, ev.target.value as SortMode)}
          >
            <InputLabel sx={{ display: 'none' }}>
              <Box sx={{ color: 'text.secondary' }}>Sort by</Box>
            </InputLabel>
            <MenuItem value={SortMode.NameAscending}>
              <RcTrans i18nKey='competition:teams.sort.name-ascending' />
            </MenuItem>
            <MenuItem value={SortMode.NameDescending}>
              <RcTrans i18nKey='competition:teams.sort.name-descending' />
            </MenuItem>
          </Select>
        </FormControl>

        <Box flexGrow={1} />

        <Stack
          direction='row'
          justifyContent={'space-between'}
          spacing={2}
          pt={3}
        >
          <Button
            disabled={
              !filterModes.includes(filterMode!) &&
              !sortModes.includes(sortMode!)
            }
            onClick={() => {
              onSelected(
                filterModes.includes(filterMode!) ? undefined : filterMode,
                sortModes.includes(sortMode!) ? undefined : sortMode
              )
            }}
            variant='outlined'
            size='small'
            color='info'
            fullWidth
          >
            <RcIcon icon={['fal', 'filter-slash']} mr={2} />
            <RcTrans i18nKey='competition:teams.actions.clear-filter' />
          </Button>
        </Stack>
      </Box>
    </>
  )
}
